import { marginFor, type CostableLine, type DocumentMargin } from './document-costing';

/**
 * Margin is measured against what the business KEEPS: sales tax is collected
 * for the state, so revenue is the post-discount grand total with tax taken
 * back out. ONE rounding, shared by every surface that prints a margin, so the
 * estimate builder and the convert-to-job review cannot disagree by a cent.
 */
export function preTaxRevenue(grandTotal: number, taxTotal: number): number {
  return Math.round((grandTotal - taxTotal) * 100) / 100;
}

/**
 * The margin a document earns, as the canonical costing measures it.
 *
 * The job form's summary rail used to roll its own figure — costBasis × qty on
 * every line, dynamic services at $0, declined services still charging for
 * their included parts — and so showed "$290 · 10%" for an estimate whose
 * builder said net +$400 at 13.75%. Both now read `marginFor`, so a saved
 * estimate costs the same wherever it is opened.
 */
export function documentMargin(
  lines: CostableLine[],
  totals: { grandTotal: number; taxTotal: number },
  pricingMode: 'STANDARD' | 'TM_OVERRIDE' = 'STANDARD',
): DocumentMargin {
  return marginFor(lines, preTaxRevenue(totals.grandTotal, totals.taxTotal), pricingMode);
}
